var cifGm = ["301 201", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v66.667H.5z'/><path fill='#FFF' d='M.5 67.167h300v66.666H.5z'/><path fill='#0C1C8C' d='M.5 78.278h300v44.444H.5z'/><path fill='#3A7728' d='M.5 133.833h300V200.5H.5z'/></g>"];

export { cifGm };

